import React, { useEffect } from 'react';
import AppRoutes from './routes/Routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LottiePageBackground from './components/base/LottiePageBackground';

function App() {

  // Zoom out the page by 20% when the app mounts
  useEffect(() => {
    const prevZoom = document.body.style.zoom;
    document.body.style.zoom = '0.8';
    return () => {
      document.body.style.zoom = prevZoom || '1';
    };
  }, []);

  return (
    <div className="App">
      <LottiePageBackground />
      <AppRoutes />
      <ToastContainer position="bottom-right" autoClose={3000} />
    </div>
  );
}

export default App;
